import { render, staticRenderFns } from "./FaqDetailView.vue?vue&type=template&id=892b82d8&scoped=true"
import script from "./FaqDetailView.vue?vue&type=script&lang=js"
export * from "./FaqDetailView.vue?vue&type=script&lang=js"
import style0 from "./FaqDetailView.vue?vue&type=style&index=0&id=892b82d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892b82d8",
  null
  
)

export default component.exports